import React, {FunctionComponent} from 'react';
import { Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import UniversityFormPage from '../../../partials/UniversityFormPage';
import {useUniversityDetailQueryConfig} from '../../../query/University/Query';

const UniversityDetail: FunctionComponent = () => {
    const { id } = useParams();

    const [universityConfig] = useUniversityDetailQueryConfig(Number(id));
    const universityQuery = useQuery(universityConfig);

    return (
        <Page className={'new-university-page'}>
            { universityQuery.data &&
                <UniversityFormPage university={universityQuery.data} />
            }
        </Page>
    );
};

export default UniversityDetail;
